import apiClient from "utils/apiClient";
import { bearerGuestToken, ensureGuestSession } from "utils/guestSession";

export const submitDemoRequest = async (payload) => {
  const guestSession = await ensureGuestSession({ refresh: true });
  const { data } = await apiClient.post(
    "/profile-service/api/v1/demo-requests",
    payload,
    {
      skipAuthContext: true,
      headers: {
        Authorization: bearerGuestToken(guestSession),
        "O-SKIP-WORKSPACE-CONTEXT": "1",
      },
    },
  );
  return data;
};
